import bronzeIcon from '../../assets/images/medals/bronze.svg';
import goldIcon from '../../assets/images/medals/gold.svg';
import silverIcon from '../../assets/images/medals/silver.svg';
export const medals = [{
  color: '#ffe27d',
  icon: goldIcon
}, {
  color: '#dde0e7',
  icon: silverIcon
}, {
  color: '#ffb48b',
  icon: bronzeIcon
}];